"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

require("react-select/dist/react-select.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactBootstrap = require("react-bootstrap");

var _underscore = _interopRequireDefault(require("underscore"));

var _caretUp = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/caret-up"));

var _caretDown = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/caret-down"));

var _check = _interopRequireDefault(require("@parchment/ui-icons/lib//ai/check-2"));

var _howItWorks = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/how-it-works"));

var _warning = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/warning"));

var _security = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/security"));

var _Option = _interopRequireDefault(require("./Option"));

var _Async = _interopRequireDefault(require("./Async"));

var _AsyncCreatable = _interopRequireDefault(require("./AsyncCreatable"));

var _Creatable = _interopRequireDefault(require("./Creatable"));

require("./Select.less");

require("./SelectMenu.less");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// TODO: multi-select
var SUCCESS = 'success';
var ERROR = 'error';
var WARNING = 'warning';

var Select = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Select);
    _this = _super.call(this, props);
    _this.getOptionLabel = _this.getOptionLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValueLabel = _this.getValueLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValidationIcon = _this.getValidationIcon.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      value: _this.getValue(props),
      visited: false
    };
    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updateOptionsWithAssumedProps(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.options !== this.props.options) {
        this.updateOptionsWithAssumedProps(nextProps);
      }

      if (nextProps.value !== this.props.value) {
        this.setState({
          value: this.getValue(nextProps)
        });
      }

      if (nextProps.selected !== this.props.selected) {
        this.setState({
          value: this.getValue(nextProps)
        });
      }
    }
  }, {
    key: "updateOptionsWithAssumedProps",
    value: function updateOptionsWithAssumedProps(_ref) {
      var _ref$options = _ref.options,
          options = _ref$options === void 0 ? [] : _ref$options,
          labelKey = _ref.labelKey,
          valueKey = _ref.valueKey;
      // don't really like this because we are mutating the props...but
      // unfortunately its necessary in order for things like dividers and
      // headers to behave properly. Such as preventing them from being
      // focused or read by screen readers. I attempted to proxy this in the
      // <Option /> component by cloning the option and adding the disabled
      // flag, which worked for the mouse navigation, but I was still able to
      // navigate to the option with the keyboard and was included in the
      // screen reader.
      // iterate over each option and if they are either a divider or a
      // header and don't explicitly have a disabled flag, we will mark
      // them as disabled so they cannot be focused using keyboard navigation
      options.forEach(function (option) {
        if ((option.divider || option.header) && typeof option.disabled === 'undefined') {
          option.disabled = true;
        } // if the value is undefined, we'll use the label as the value


        if (!option.disabled && typeof option[valueKey] === 'undefined' && typeof option[labelKey] !== 'undefined') {
          option[valueKey] = option[labelKey];
        }
      });
    }
  }, {
    key: "getOptionLabel",
    value: function getOptionLabel(op) {
      if (!op.header && op.divider) {
        return /*#__PURE__*/_react.default.createElement("hr", null);
      }

      return /*#__PURE__*/_react.default.createElement("span", null, op.required && /*#__PURE__*/_react.default.createElement("span", {
        className: "text-danger"
      }, "* "), op[this.props.labelKey]);
    }
  }, {
    key: "getValueLabel",
    value: function getValueLabel(op) {
      var validationIcon = this.getValidationIcon();
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(validationIcon && 'has-validation-icon')
      }, validationIcon, op[this.props.labelKey]);
    }
  }, {
    key: "getValidationIcon",
    value: function getValidationIcon() {
      var validationState = this.getValidationState();

      switch (true) {
        case !validationState && this.props.required:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "validation-state-icon is-required",
            "aria-hidden": "true"
          }, /*#__PURE__*/_react.default.createElement("span", null, "*"));

        case validationState === ERROR:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "validation-state-icon",
            "aria-hidden": "true"
          }, /*#__PURE__*/_react.default.createElement(_warning.default, {
            noPad: true
          }));

        case validationState === WARNING:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "validation-state-icon",
            "aria-hidden": "true"
          }, /*#__PURE__*/_react.default.createElement(_howItWorks.default, {
            noPad: true
          }));

        case validationState === SUCCESS:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "validation-state-icon",
            "aria-hidden": "true"
          }, /*#__PURE__*/_react.default.createElement(_check.default, {
            noPad: true
          }));

        case this.props.disabled:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "validation-state-icon",
            "aria-hidden": "true"
          }, /*#__PURE__*/_react.default.createElement(_security.default, {
            noPad: true
          }));

        default:
          return null;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.setState({
        focused: true
      });
      this.props.onFocus && this.props.onFocus(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.setState({
        visited: true,
        focused: false
      });
      this.props.onBlur && this.props.onBlur(e);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // return the value prop by default
      // otherwise fallback to the <Dropdown /> version of value, which was a prop named selected, but that took the whole option, instead of the option value
      var value = _underscore.default.find([props.value, (props.selected || {})[props.valueKey]], function (v) {
        return !_underscore.default.isUndefined(v);
      }); // if value is null, or an empty string, or is not a valid option, then set value to undefined


      if (value === null || "".concat(value).length === 0 || typeof value !== 'undefined' && !props.options.some(function (o) {
        return o[props.valueKey] === value || o[props.labelKey] === value;
      })) {
        value = undefined;
      }

      return value;
    }
  }, {
    key: "getValidationState",
    value: function getValidationState() {
      if (this.props.validationState !== undefined || !this.props.required) {
        return this.props.validationState;
      }

      return this.getValue() ? SUCCESS : this.state.visited && ERROR;
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var placeholder = this.props.title || this.props.placeholder;

      if (!this.props.valueRenderer || this.props.valueRenderer === this.getValueLabel) {
        return this.getValueLabel((0, _defineProperty2.default)({}, this.props.labelKey, placeholder));
      }

      return placeholder;
    }
  }, {
    key: "renderErrorToolTip",
    value: function renderErrorToolTip() {
      var validationState = this.getValidationState();
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        className: "error-overlay",
        show: validationState === ERROR && this.state.visited,
        container: this,
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
        className: "error-tooltip",
        id: "error-tooltip-for-".concat(this.props.errorTitle),
        placement: "top",
        title: this.props.errorTitle ? this.props.errorTitle : ERROR
      }, this.props.errorMessage));
    }
  }, {
    key: "getFocusedOption",
    value: function getFocusedOption() {
      return this.select.getFocusedOption();
    }
  }, {
    key: "selectValue",
    value: function selectValue(option) {
      return this.select.selectValue(option);
    }
  }, {
    key: "focus",
    value: function focus() {
      return this.select.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var validationState = this.getValidationState();
      var className = (0, _classnames.default)('primitive-select', this.props.className, "size-".concat(this.props.size), "theme-".concat(this.props.theme), (0, _defineProperty2.default)({
        'block': this.props.block,
        'is-required': this.props.required,
        'is-focused': this.state.focused
      }, "has-".concat(validationState), !!validationState));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, (0, _extends2.default)({}, this.props, {
        onChange: function onChange(value) {
          _this2.setState({
            value: value
          });

          if (typeof _this2.props.onChange === 'function') {
            _this2.props.onChange(value);
          }
        },
        value: this.state.value,
        className: "",
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        placeholder: this.getPlaceholder(),
        optionRenderer: this.props.optionRenderer || this.getOptionLabel,
        valueRenderer: this.props.valueRenderer || this.getValueLabel,
        ref: function ref(n) {
          return _this2.select = n;
        }
      })), this.props.errorToolTip && this.renderErrorToolTip());
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread(_objectSpread({}, _reactSelect.default.propTypes), {}, {
        size: _propTypes.default.oneOf(['smallest', 'small', 'default', 'large']),
        block: _propTypes.default.bool,
        required: _propTypes.default.bool,
        validationState: _propTypes.default.oneOf([SUCCESS, WARNING, ERROR, null]),
        theme: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'light', 'dark', SUCCESS, WARNING, ERROR]),
        errorToolTip: _propTypes.default.bool,
        errorTitle: _propTypes.default.node,
        errorMessage: _propTypes.default.node
      });
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        valueKey: 'id',
        labelKey: 'description',
        placeholder: _reactSelect.default.defaultProps.placeholder,
        arrowRenderer: Select.getArrow,
        clearable: false,
        size: 'default',
        block: true,
        required: false,
        optionComponent: _Option.default,
        theme: 'default',
        errorToolTip: false,
        errorTitle: 'Error',
        errorMessage: 'This field is required'
      };
    }
  }, {
    key: "getArrow",
    value: function getArrow(_ref2) {
      var onMouseDown = _ref2.onMouseDown,
          isOpen = _ref2.isOpen;
      var ArrowIcon = isOpen ? _caretUp.default : _caretDown.default;
      return /*#__PURE__*/_react.default.createElement(ArrowIcon, {
        noPad: true,
        className: "".concat(isOpen ? 'is-open' : 'is-closed'),
        onMouseDown: onMouseDown
      });
    }
  }]);
  return Select;
}(_react.default.Component);

exports.default = Select;
Select.Option = _Option.default;
Select.Creatable = _Creatable.default;
Select.Async = _Async.default;
Select.AsyncCreatable = _AsyncCreatable.default;